import OrganizationListPresenter from "./OrganizationList/OrganizationListPresenter";

export const OrganizationList = {
    List: OrganizationListPresenter
}

export default OrganizationList;